import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'fb-page-header',
    imports: [RouterLink],
    template: `
        <header class="flex flex-wrap items-end justify-between gap-4 mb-6">
            <div class="flex flex-col gap-1 min-w-0">
                @if (backLink()) {
                    <a
                        [routerLink]="backLink()"
                        class="inline-flex items-center gap-1 text-sm text-text-muted hover:text-text transition-colors w-fit">
                        <i class="ph ph-arrow-left"></i>
                        <span>{{ backLabel() }}</span>
                    </a>
                }
                <h1 class="font-display font-bold text-2xl text-text truncate">{{ title() }}</h1>
                @if (subtitle()) {
                    <p class="text-sm text-text-muted">{{ subtitle() }}</p>
                }
            </div>
            <div class="flex items-center gap-2">
                <ng-content select="[actions]" />
            </div>
        </header>
    `
})
export class PageHeaderComponent {
    title = input.required<string>();
    subtitle = input<string>();
    backLink = input<string | unknown[]>();
    backLabel = input<string>('');
}
